import type { IEventSlot } from '@api/EventSlotsApi';
import { writableSessionStorage } from './writableSessionStorage';

export interface IEventStore {
	selectedEventId?: string;
	selectedSlot?: IEventSlot;
	highestCompletedCheckoutStep: number;
	loadingState: boolean;
}

const initEventData: IEventStore = {
	selectedEventId: undefined,
	selectedSlot: undefined,
	highestCompletedCheckoutStep: 1,
	loadingState: false
};

const createEventStore = () => {
	const { subscribe, set, update } = writableSessionStorage('eventStore', initEventData);

	return {
		subscribe,
		set,
		update
	};
};

export const eventStore = createEventStore();
